import {isIOS, isAndroid, isMobile} from 'mobile-device-detect';

export class ClientDeviceType {

    public static isMobileOrTablet(): boolean {
        return isMobile;
    }

    public static isIOS(): boolean {
        return isIOS;
    }

    public static isAndroid(): boolean {
        return isAndroid;
    }
}
